export default {
    'application/json': 'JSON Document',
    'application/pdf': 'PDF Document',
    'application/xml': 'XML Document',
    'text/plain': 'Plain Text Document',
    'image/jpeg': 'JPEG Image',
    'image/png': 'PNG Image',
    'image/svg+xml': 'SVG Image',
    'image/gif': 'GIF Image',
    'audio/mpeg': 'MP3 Audio',
    'audio/wav': 'WAV Audio',
    'video/mp4': 'MP4 Video',
    'video/quicktime': 'QuickTime Video',
    'application/msword': 'MS Word',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'MS Word',
    'application/vnd.ms-excel': 'MS Excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'MS Excel',
    'application/vnd.ms-powerpoint': 'MS PowerPoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'MS PowerPoint',
    'application/zip': 'ZIP Archive',
    'application/x-tar': 'Tar Archive',
    'application/x-gzip': 'GZIP Archive',
    'application/x-bzip2': 'BZIP2 Archive',
    'text/html': 'HTML Document',
    'application/xhtml+xml': 'XHTML Document',
    'application/javascript': 'JavaScript File',
    'text/css': 'CSS Stylesheet',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12': 'MS PowerPoint Macro-Enabled',
    'application/vnd.ms-word.document.macroEnabled.12': 'MS Word Macro-Enabled',
    'application/vnd.ms-excel.sheet.macroEnabled.12': 'MS Excel Macro-Enabled',
    'application/vnd.oasis.opendocument.text': 'OpenDocument Text',
    'application/vnd.oasis.opendocument.spreadsheet': 'OpenDocument Spreadsheet',
    'application/vnd.oasis.opendocument.presentation': 'OpenDocument Presentation',
    'application/ogg': 'OGG Media',
    'audio/flac': 'FLAC Audio',
    'video/x-msvideo': 'AVI Video',
    'video/x-matroska': 'Matroska Video',
    'application/x-shockwave-flash': 'Flash Animation',
    'application/vnd.android.package-archive': 'Android Package',
    'application/vnd.apple.keynote': 'Apple Keynote',
    'application/vnd.apple.pages': 'Apple Pages',
    'application/vnd.apple.numbers': 'Apple Numbers',
    'application/vnd.google-apps.document': 'Google Docs Document',
    'application/vnd.google-apps.spreadsheet': 'Google Sheets Spreadsheet',
    'application/vnd.google-apps.presentation': 'Google Slides Presentation',
    'application/vnd.google-earth.kml+xml': 'KML Document',
    'application/vnd.google-earth.kmz': 'KMZ Document',
    'application/vnd.mozilla.xul+xml': 'XUL Document',
    'application/x-dvi': 'DVI Document',
    'application/x-latex': 'LaTeX Document',
    'application/x-mobipocket-ebook': 'Mobipocket eBook',
    'application/x-msdownload': 'Executable Program',
    'application/x-rar-compressed': 'RAR Archive',
    'application/x-tex': 'TeX Document',
    'application/x-texinfo': 'Texinfo Document',
    'application/x-7z-compressed': '7z Archive',
    'audio/aac': 'AAC Audio',
    'audio/x-aiff': 'AIFF Audio',
    'image/bmp': 'Bitmap Image',
    'image/webp': 'WebP Image',
    'text/csv': 'CSV File',
    'text/calendar': 'Calendar File',
};
//# sourceMappingURL=mimeTypeLabels.js.map